export default __webpack_public_path__ + "static/media/bt.7c629ea7.svg";